import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid,
  Paper,
  Divider,
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { ArrowDropDownSharp } from '@material-ui/icons/';
import Page from 'src/components/Page';
import {
  TabPanel,
  TabList,
  TabContext
} from '@material-ui/lab';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionActions from '@material-ui/core/AccordionActions';

import Input from '../../shared/component/FormElements/Input';
import Seletor from '../../shared/component/FormElements/Seletor';
import Avatar from '../../shared/component/FormElements/Avatar';
import Draft from '../../shared/component/FormElements/Draft';
import Button from '../../shared/component/FormElements/Button';
import Alerta from '../perfil/Alerta';
import Modal from '../../shared/component/Modal';
import ErrorMessage from '../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../shared/component/UIElements/LoadingSpinner';
import { useForm } from '../../hooks/form-hook';
import { useHttpClient } from '../../hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';

import Faq from './components/faq';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3A3A3A',
    fontWeight: 700,
    fontSize: '24px',
    marginBottom: '15px'
  },
  button: {
    marginTop: '15px',
    display: 'block',
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px'
  },
  tabela: {
    backgroundColor: '#f4f6f8',
    '& > .MuiTabs-scroller': {
      backgroundColor: '#f4f6f8',
    }
  },
  tab: {
    padding: '24px 0px'
  },
  faq: {
    margin: '30px 0px'
  }
}));

const Front = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [aba, setAba] = useState('0');
  const [acervo, setAcervo] = useState([]);
  const [inst, setInstitucional] = useState(false);
  const [faq, setFaq] = useState(false);
  const [editFaq, setEditfaq] = useState(undefined);
  const [faqs, setFaqs] = useState([]);
  const [expanded, setExpanded] = useState(0);
  const [salvou, setSalvou] = useState(false);
  console.log(faqs);
  const fechar = () => {
    setSalvou(false);
  };
  const handleChange = (event, newValue) => {
    setAba(newValue);
  };
  const handleChangeAcord = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler] = useForm({
    'home-area1-fundo': {
      value: '',
      isValid: false
    },
    'home-area1-titulo': {
      value: '',
      isValid: false
    },
    'home-area1-chamada': {
      value: '',
      isValid: false
    },
    'home-area1-destaque': {
      value: '',
      isValid: false
    },
    'home-area4-fundo': {
      value: '',
      isValid: false
    },
    'home-area4-subtitulo': {
      value: '',
      isValid: false
    },
    'home-area4-titulo': {
      value: '',
      isValid: false
    },
    'home-area4-chamada': {
      value: '',
      isValid: false
    },
    'home-area4-botao-link': {
      value: '',
      isValid: false
    },
    'home-area4-botao-texto': {
      value: '',
      isValid: false
    },
    'home-area5-titulo': {
      value: '',
      isValid: false
    },
    'home-area5-chamada': {
      value: '',
      isValid: false
    },
    'home-area5-mapa': {
      value: '',
      isValid: false
    },
    'segunda-manha': {
      value: '',
      isValid: false
    },
    'segunda-tarde': {
      value: '',
      isValid: false
    },
    'segunda-noite': {
      value: '',
      isValid: false
    },
    'terca-manha': {
      value: '',
      isValid: false
    },
    'terca-tarde': {
      value: '',
      isValid: false
    },
    'terca-noite': {
      value: '',
      isValid: false
    },
    'quarta-manha': {
      value: '',
      isValid: false
    },
    'quarta-tarde': {
      value: '',
      isValid: false
    },
    'quarta-noite': {
      value: '',
      isValid: false
    },
    'quinta-manha': {
      value: '',
      isValid: false
    },
    'quinta-tarde': {
      value: '',
      isValid: false
    },
    'quinta-noite': {
      value: '',
      isValid: false
    },
    'sexta-manha': {
      value: '',
      isValid: false
    },
    'sexta-tarde': {
      value: '',
      isValid: false
    },
    'sexta-noite': {
      value: '',
      isValid: false
    },
    'sabado-manha': {
      value: '',
      isValid: false
    },
    'sabado-tarde': {
      value: '',
      isValid: false
    },
    'sabado-noite': {
      value: '',
      isValid: false
    },
    'domingo-manha': {
      value: '',
      isValid: false
    },
    'domingo-tarde': {
      value: '',
      isValid: false
    },
    'domingo-noite': {
      value: '',
      isValid: false
    },
    'memorial-area1-fundo': {
      value: '',
      isValid: false
    },
    'memorial-area1-titulo': {
      value: '',
      isValid: false
    },
    'memorial-area1-chamada': {
      value: '',
      isValid: false
    },
    'memorial-area2-descricao': {
      value: '',
      isValid: false
    },
    'memorial-area2-destaque': {
      value: '',
      isValid: false
    },
    'memorial-area3-anexo1': {
      value: '',
      isValid: false
    },
    'memorial-area3-anexo2': {
      value: '',
      isValid: false
    },
    'memorial-area3-anexo3': {
      value: '',
      isValid: false
    },
    'memorial-area4-descricao': {
      value: '',
      isValid: false
    },
    'memorial-area4-citacao': {
      value: '',
      isValid: false
    },
    'memorial-area4-citacao-quem': {
      value: '',
      isValid: false
    },
    'contato-area1-fundo': {
      value: '',
      isValid: false
    },
    'contato-area1-titulo': {
      value: '',
      isValid: false
    },
    'contato-area1-chamada': {
      value: '',
      isValid: false
    },
    'contato-area2-descricao': {
      value: '',
      isValid: false
    },
    'contato-area4-fundo': {
      value: '',
      isValid: false
    },
    'contato-area4-titulo': {
      value: '',
      isValid: false
    },
    'contato-area4-chamada': {
      value: '',
      isValid: false
    },
    'contato-area4-botao': {
      value: '',
      isValid: false
    },
    'contato-area4-botao-link': {
      value: '',
      isValid: false
    },
    'infos-rua': {
      value: '',
      isValid: false
    },
    'infos-bairro': {
      value: '',
      isValid: false
    },
    'infos-cep': {
      value: '',
      isValid: false
    },
    'infos-cidade': {
      value: '',
      isValid: false
    },
    'infos-telefone': {
      value: '',
      isValid: false
    },
    'infos-email': {
      value: '',
      isValid: false
    },
    'infos-whats': {
      value: '',
      isValid: false
    },
    'infos-instagram': {
      value: '',
      isValid: false
    },
    'acervos-area1-titulo': {
      value: '',
      isValid: false
    },
    'acervos-area1-chamada': {
      value: '',
      isValid: false
    },
    'acervos-area1-destaque': {
      value: '',
      isValid: false
    },
    'acervos-area3-subtitulo': {
      value: '',
      isValid: false
    },
    'acervos-area3-titulo': {
      value: '',
      isValid: false
    },
    'acervos-area3-chamada': {
      value: '',
      isValid: false
    },
    'acervos-area3-botao': {
      value: '',
      isValid: false
    },
    'acervos-area3-botao-link': {
      value: '',
      isValid: false
    },
    'acervos-area3-destaque': {
      value: '',
      isValid: false
    },
    'acervos-area4-fundo': {
      value: '',
      isValid: false
    },
    'acervos-area4-titulo': {
      value: '',
      isValid: false
    },
    'acervos-area4-chamada': {
      value: '',
      isValid: false
    },
    'acervos-area4-botao': {
      value: '',
      isValid: false
    },
    'acervos-area4-botao-link': {
      value: '',
      isValid: false
    },
    'emprestimo-area1-titulo': {
      value: '',
      isValid: false
    },
    'emprestimo-area2-descricao': {
      value: '',
      isValid: false
    },
    'emprestimo-area2-destaque': {
      value: '',
      isValid: false
    },
    'faq-area1-titulo': {
      value: '',
      isValid: false
    },
    'faq-area1-chamada': {
      value: '',
      isValid: false
    },
    'faq-area2-titulo': {
      value: '',
      isValid: false
    },
    'faq-area2-descricao': {
      value: '',
      isValid: false
    },
    'faq-area2-destaque': {
      value: '',
      isValid: false
    },
    'faq-area3-destaque': {
      value: '',
      isValid: false
    },
    'faq-area3-titulo': {
      value: '',
      isValid: false
    },
    'faq-area3-descricao': {
      value: '',
      isValid: false
    },
    'faq-area3-botao': {
      value: '',
      isValid: false
    },
    'faq-area3-botao-link': {
      value: '',
      isValid: false
    },
    'faq-area5-titulo': {
      value: '',
      isValid: false
    },
    'faq-area5-chamada': {
      value: '',
      isValid: false
    },
    'faq-area5-botao': {
      value: '',
      isValid: false
    },
    'faq-area5-botao-link': {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const formulario = new FormData();
      // Home
      formulario.append('home-area1-fundo', formState.inputs['home-area1-fundo'].value);
      formulario.append('home-area1-titulo', formState.inputs['home-area1-titulo'].value);
      formulario.append('home-area1-chamada', formState.inputs['home-area1-chamada'].value);
      formulario.append('home-area1-destaque', formState.inputs['home-area1-destaque'].value);
      formulario.append('home-area4-fundo', formState.inputs['home-area4-fundo'].value);
      formulario.append('home-area4-subtitulo', formState.inputs['home-area4-subtitulo'].value);
      formulario.append('home-area4-titulo', formState.inputs['home-area4-titulo'].value);
      formulario.append('home-area4-chamada', formState.inputs['home-area4-chamada'].value);
      formulario.append('home-area4-botao-link', formState.inputs['home-area4-botao-link'].value);
      formulario.append('home-area4-botao-texto', formState.inputs['home-area4-botao-texto'].value);
      formulario.append('home-area5-titulo', formState.inputs['home-area5-titulo'].value);
      formulario.append('home-area5-chamada', formState.inputs['home-area5-chamada'].value);
      formulario.append('home-area5-mapa', formState.inputs['home-area5-mapa'].value);
      formulario.append('segunda-manha', formState.inputs['segunda-manha'].value);
      formulario.append('segunda-tarde', formState.inputs['segunda-tarde'].value);
      formulario.append('segunda-noite', formState.inputs['segunda-noite'].value);
      formulario.append('terca-manha', formState.inputs['terca-manha'].value);
      formulario.append('terca-tarde', formState.inputs['terca-tarde'].value);
      formulario.append('terca-noite', formState.inputs['terca-noite'].value);
      formulario.append('quarta-manha', formState.inputs['quarta-manha'].value);
      formulario.append('quarta-tarde', formState.inputs['quarta-tarde'].value);
      formulario.append('quarta-noite', formState.inputs['quarta-noite'].value);
      formulario.append('quinta-manha', formState.inputs['quinta-manha'].value);
      formulario.append('quinta-tarde', formState.inputs['quinta-tarde'].value);
      formulario.append('quinta-noite', formState.inputs['quinta-noite'].value);
      formulario.append('sexta-manha', formState.inputs['sexta-manha'].value);
      formulario.append('sexta-tarde', formState.inputs['sexta-tarde'].value);
      formulario.append('sexta-noite', formState.inputs['sexta-noite'].value);
      formulario.append('sabado-manha', formState.inputs['sabado-manha'].value);
      formulario.append('sabado-tarde', formState.inputs['sabado-tarde'].value);
      formulario.append('sabado-noite', formState.inputs['sabado-noite'].value);
      formulario.append('domingo-manha', formState.inputs['domingo-manha'].value);
      formulario.append('domingo-tarde', formState.inputs['domingo-tarde'].value);
      formulario.append('domingo-noite', formState.inputs['domingo-noite'].value);
      // O MEMORIAL
      formulario.append('memorial-area1-fundo', formState.inputs['memorial-area1-fundo'].value);
      formulario.append('memorial-area1-titulo', formState.inputs['memorial-area1-titulo'].value);
      formulario.append('memorial-area1-chamada', formState.inputs['memorial-area1-chamada'].value);
      formulario.append('memorial-area2-descricao', formState.inputs['memorial-area2-descricao'].value);
      formulario.append('memorial-area2-destaque', formState.inputs['memorial-area2-destaque'].value);
      formulario.append('memorial-area3-anexo1', formState.inputs['memorial-area3-anexo1'].value);
      formulario.append('memorial-area3-anexo2', formState.inputs['memorial-area3-anexo2'].value);
      formulario.append('memorial-area3-anexo3', formState.inputs['memorial-area3-anexo3'].value);
      formulario.append('memorial-area4-descricao', formState.inputs['memorial-area4-descricao'].value);
      formulario.append('memorial-area4-citacao', formState.inputs['memorial-area4-citacao'].value);
      formulario.append('memorial-area4-citacao-quem', formState.inputs['memorial-area4-citacao-quem'].value);
      // CONTATO
      formulario.append('contato-area1-fundo', formState.inputs['contato-area1-fundo'].value);
      formulario.append('contato-area1-titulo', formState.inputs['contato-area1-titulo'].value);
      formulario.append('contato-area1-chamada', formState.inputs['contato-area1-chamada'].value);
      formulario.append('contato-area2-descricao', formState.inputs['contato-area2-descricao'].value);
      formulario.append('contato-area4-fundo', formState.inputs['contato-area4-fundo'].value);
      formulario.append('contato-area4-titulo', formState.inputs['contato-area4-titulo'].value);
      formulario.append('contato-area4-chamada', formState.inputs['contato-area4-chamada'].value);
      formulario.append('contato-area4-botao', formState.inputs['contato-area4-botao'].value);
      formulario.append('contato-area4-botao-link', formState.inputs['contato-area4-botao-link'].value);
      // INFOS
      formulario.append('infos-rua', formState.inputs['infos-rua'].value);
      formulario.append('infos-bairro', formState.inputs['infos-bairro'].value);
      formulario.append('infos-cep', formState.inputs['infos-cep'].value);
      formulario.append('infos-cidade', formState.inputs['infos-cidade'].value);
      formulario.append('infos-telefone', formState.inputs['infos-telefone'].value);
      formulario.append('infos-email', formState.inputs['infos-email'].value);
      formulario.append('infos-whats', formState.inputs['infos-whats'].value);
      formulario.append('infos-instagram', formState.inputs['infos-instagram'].value);
      // ACERVOS
      formulario.append('acervos-area1-titulo', formState.inputs['acervos-area1-titulo'].value);
      formulario.append('acervos-area1-chamada', formState.inputs['acervos-area1-chamada'].value);
      formulario.append('acervos-area1-destaque', formState.inputs['acervos-area1-destaque'].value);
      formulario.append('acervos-area3-subtitulo', formState.inputs['acervos-area3-subtitulo'].value);
      formulario.append('acervos-area3-titulo', formState.inputs['acervos-area3-titulo'].value);
      formulario.append('acervos-area3-chamada', formState.inputs['acervos-area3-chamada'].value);
      formulario.append('acervos-area3-botao', formState.inputs['acervos-area3-botao'].value);
      formulario.append('acervos-area3-botao-link', formState.inputs['acervos-area3-botao-link'].value);
      formulario.append('acervos-area3-destaque', formState.inputs['acervos-area3-destaque'].value);
      formulario.append('acervos-area4-fundo', formState.inputs['acervos-area4-fundo'].value);
      formulario.append('acervos-area4-titulo', formState.inputs['acervos-area4-titulo'].value);
      formulario.append('acervos-area4-chamada', formState.inputs['acervos-area4-chamada'].value);
      formulario.append('acervos-area4-botao', formState.inputs['acervos-area4-botao'].value);
      formulario.append('acervos-area4-botao-link', formState.inputs['acervos-area4-botao-link'].value);
      // EMPRESTIMO
      formulario.append('emprestimo-area1-titulo', formState.inputs['emprestimo-area1-titulo'].value);
      formulario.append('emprestimo-area2-descricao', formState.inputs['emprestimo-area2-descricao'].value);
      formulario.append('emprestimo-area2-destaque', formState.inputs['emprestimo-area2-destaque'].value);
      // FAQ
      formulario.append('faq-area1-titulo', formState.inputs['faq-area1-titulo'].value);
      formulario.append('faq-area1-chamada', formState.inputs['faq-area1-chamada'].value);
      formulario.append('faq-area2-titulo', formState.inputs['faq-area2-titulo'].value);
      formulario.append('faq-area2-descricao', formState.inputs['faq-area2-descricao'].value);
      formulario.append('faq-area2-destaque', formState.inputs['faq-area2-destaque'].value);
      formulario.append('faq-area3-destaque', formState.inputs['faq-area3-destaque'].value);
      formulario.append('faq-area3-titulo', formState.inputs['faq-area3-titulo'].value);
      formulario.append('faq-area3-descricao', formState.inputs['faq-area3-descricao'].value);
      formulario.append('faq-area3-botao', formState.inputs['faq-area3-botao'].value);
      formulario.append('faq-area3-botao-link', formState.inputs['faq-area3-botao-link'].value);
      formulario.append('faq-area5-titulo', formState.inputs['faq-area5-titulo'].value);
      formulario.append('faq-area5-chamada', formState.inputs['faq-area5-chamada'].value);
      formulario.append('faq-area5-botao', formState.inputs['faq-area5-botao'].value);
      formulario.append('faq-area5-botao-link', formState.inputs['faq-area5-botao-link'].value);
      console.log(faqs);
      formulario.append('faq-perguntas', JSON.stringify(faqs));
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/institucional`,
        'POST',
        formulario,
        {
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        setSalvou(true);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    const fetchAcervos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/acervo`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
          }
        );
        console.log(responseData);
        setAcervo(responseData.acervos);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAcervos();
  }, [sendRequest, auth]);

  useEffect(() => {
    const fetchInstitucional = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/institucional`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        console.log('Conteúdo Institucional');
        console.log(responseData.data);
        setInstitucional(responseData.data);
        setFaqs(responseData.data.faq.perguntas);
      } catch (err) {
        console.log(err);
      }
    };
    fetchInstitucional();
  }, [sendRequest, auth, aba]);

  const dias = [
    { id: 'segunda', label: 'Segunda-Feira' },
    { id: 'terca', label: 'Terça-Feira' },
    { id: 'quarta', label: 'Quarta-Feira' },
    { id: 'quinta', label: 'Quinta-Feira' },
    { id: 'sexta', label: 'Sexta-Feira' },
    { id: 'sabado', label: 'Sábado' },
    { id: 'domingo', label: 'Domingo' },
  ];

  const handleCloseFaq = () => {
    setFaq(false);
  };

  const handleAddFaq = (nova) => {
    setFaqs((prevState) => {
      const old = prevState;
      old.push(nova);
      return old;
    });
    setFaq(false);
  };

  const handleAttFaq = (edicao) => {
    setFaqs((prevState) => {
      const old = prevState;
      const qual = old.indexOf(edicao.qual);
      old[qual] = {
        pergunta: edicao.pergunta,
        resposta: edicao.resposta,
      };
      return old;
    });
    setEditfaq(undefined);
  };

  const handleRmvFaq = (rmv) => {
    setFaqs((prevState) => {
      const old = prevState;
      const qual = old.indexOf(rmv);
      delete old[qual];
      if (expanded === qual) {
        setExpanded(false);
      }
      return old;
    });
  };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowDropDownSharp sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

  if (!inst) {
    return (
      <Page
        className={classes.root}
        title="Conteúdo do Site"
      >
        <Container maxWidth="lg">
          Carregando....
        </Container>
      </Page>
    );
  }

  return (
    <Page
      className={classes.root}
      title="Conteúdo do Site"
    >
      <Container maxWidth="lg">
        <TabContext value={aba}>
          <AppBar position="static" color="default">
            <TabList
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              aria-label="simple tabs example"
              className={classes.tabela}
            >
              <Tab label="Home do Site" value="0" id="home" />
              <Tab label="O Memorial" value="1" id="memorial" />
              <Tab label="Informações de Contato" value="2" id="infos" />
              <Tab label="Acervos" value="3" id="acervos" />
              <Tab label="Como Solicitar Empréstimo" value="4" id="emprestimos" />
              <Tab label="F.A.Q." value="5" id="faq" />
            </TabList>
          </AppBar>
          <form onSubmit={novoSubmitHandler}>
            <TabPanel className={classes.tab} value="0">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="home-area1-fundo"
                          name="area1-fundo"
                          onInput={inputHandler}
                          validators={[]}
                          initialValue={inst.home.area1.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.home.area1.fundo.caminho}` : ''}
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="home-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area1.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area1-chamada"
                          element="input"
                          type="text"
                          label="Chamada do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area1.chamada}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Seletor
                          id="home-area1-destaque"
                          name="home-area1-destaque"
                          onInput={inputHandler}
                          label="Item do Acervo de Destaque"
                          placeholder="Destaque do Acervo"
                          blank="Selecione o Destaque do Acervo"
                          fullWidth
                          variant="outlined"
                          data={acervo.map((n) => {
                            return { label: n.nome, id: n._id };
                          })}
                          multiple
                          initialValue={inst.home.area1.destaque !== null ? inst.home.area1.destaque.map((d) => d._id) : []}
                          errorText="Selecione o Arquivo do Acervo."
                          validators={[]}
                          initialValid
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 4 - O Memorial
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="home-area4-fundo"
                          name="area4-fundo"
                          onInput={inputHandler}
                          initialValue={inst.home.area4.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.home.area4.fundo.caminho}` : ''}
                          validators={[]}
                          initialValid
                          errorText="Insira o avatar do usuário."
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="home-area4-subtitulo"
                          element="input"
                          type="text"
                          label="Sub-Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area4.subtitulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area4-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area4.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area4-chamada"
                          element="input"
                          type="textarea"
                          rows={3}
                          multiline
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.home.area4.chamada}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area4-botao-link"
                          element="input"
                          type="text"
                          label="Link do botão"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area4.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area4-botao-texto"
                          element="input"
                          type="text"
                          label="Texto do botão"
                          fullWidth
                          initialValue={inst.home.area4.botao.texto}
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 5 - Visitação
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Input
                          id="home-area5-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area5.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area5-chamada"
                          element="input"
                          type="textarea"
                          rows={2}
                          multiline
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area5.chamada}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="home-area5-mapa"
                          element="input"
                          type="textarea"
                          label="Iframe do Mapa da Área"
                          fullWidth
                          multiline
                          rows={5}
                          validators={[]}
                          initialValid
                          initialValue={inst.home.area5.mapa}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid item xs={3} />
                      <Grid item xs={3}>
                        Manhã
                      </Grid>
                      <Grid item xs={3}>
                        Tarde
                      </Grid>
                      <Grid item xs={3}>
                        Noite
                      </Grid>
                    </Grid>
                    {dias.map((dia) => (
                      <Grid
                        container
                        spacing={3}
                        key={dia.id}
                        alignItems="center"
                      >
                        <Grid item xs={3}>
                          {dia.label}
                        </Grid>
                        <Grid item xs={3}>
                          <Input
                            id={`${dia.id}-manha`}
                            element="input"
                            type="text"
                            label="Período"
                            fullWidth
                            validators={[]}
                            initialValid
                            initialValue={inst.dias[dia.id].manha}
                            onInput={inputHandler}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Input
                            id={`${dia.id}-tarde`}
                            element="input"
                            type="text"
                            label="Período"
                            fullWidth
                            validators={[]}
                            initialValid
                            initialValue={inst.dias[dia.id].tarde}
                            onInput={inputHandler}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <Input
                            id={`${dia.id}-noite`}
                            element="input"
                            type="text"
                            label="Período"
                            fullWidth
                            validators={[]}
                            initialValid
                            initialValue={inst.dias[dia.id].noite}
                            onInput={inputHandler}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                    ))}
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel className={classes.tab} value="1">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="memorial-area1-fundo"
                          name="memorial-area1-fundo"
                          onInput={inputHandler}
                          initialValue={inst.memorial.area1.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.memorial.area1.fundo.caminho}` : ''}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="memorial-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.memorial.area1.titulo}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="memorial-area1-chamada"
                          element="input"
                          type="text"
                          label="Chamada do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.memorial.area1.chamada}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 2 - Descrição
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Draft
                          id="memorial-area2-descricao"
                          element="input"
                          type="text"
                          label="Descrição do Memorial"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.memorial.area2.descricao}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Seletor
                          id="memorial-area2-destaque"
                          name="memorial-destaque"
                          onInput={inputHandler}
                          label="Item do Acervo de Destaque"
                          placeholder="Destaque do Acervo"
                          blank="Selecione o Destaque do Acervo"
                          fullWidth
                          variant="outlined"
                          data={acervo.map((n) => {
                            return { label: n.nome, id: n._id };
                          })}
                          initialValue={inst.memorial.area2.destaque !== null ? inst.memorial.area2.destaque.map((d) => d._id) : []}
                          errorText="Selecione o Arquivo do Acervo."
                          validators={[]}
                          initialValid
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 3 - Anexos
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <Avatar
                          id="memorial-area3-anexo1"
                          name="memorial-area3-anexo1"
                          initialValue={inst.memorial.area3.anexo1 !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.memorial.area3.anexo1.caminho}` : ''}
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Avatar
                          id="memorial-area3-anexo2"
                          name="memorial-area3-anexo2"
                          onInput={inputHandler}
                          initialValue={inst.memorial.area3.anexo2 !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.memorial.area3.anexo2.caminho}` : ''}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Avatar
                          id="memorial-area3-anexo3"
                          name="memorial-area3-anexo3"
                          initialValue={inst.memorial.area3.anexo3 !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.memorial.area3.anexo3.caminho}` : ''}
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 4 - Textos
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Draft
                          id="memorial-area4-descricao"
                          element="input"
                          type="text"
                          label="Descrição do Memorial"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.memorial.area4.descricao}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Draft
                          id="memorial-area4-citacao"
                          element="input"
                          type="text"
                          label="Citação do Memorial"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.memorial.area4.citacao.texto}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="memorial-area4-citacao-quem"
                          element="input"
                          type="text"
                          label="Autor da Citação"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.memorial.area4.citacao.quem}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel className={classes.tab} value="2">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="contato-area1-fundo"
                          name="contato-fundo"
                          initialValue={inst.contato.area1.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.contato.area1.fundo.caminho}` : ''}
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="contato-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValue={inst.contato.area1.titulo}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="contato-area1-chamada"
                          element="input"
                          type="text"
                          label="Chamada do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area1.chamada}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 2 - Formulário de Contato
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Draft
                          id="contato-area2-descricao"
                          element="input"
                          type="text"
                          label="Descrição lateral do formulário"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area2.descricao}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 4 - Visitas
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="contato-area4-fundo"
                          name="contato-fundo"
                          onInput={inputHandler}
                          validators={[]}
                          initialValue={inst.contato.area4.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.contato.area4.fundo.caminho}` : ''}
                          initialValid
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="contato-area4-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area4.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="contato-area4-chamada"
                          element="input"
                          type="text"
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area4.chamada}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="contato-area4-botao"
                          element="input"
                          type="text"
                          label="Texto do botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area4.botao.texto}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="contato-area4-botao-link"
                          element="input"
                          type="text"
                          label="Link do Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.contato.area4.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Endereço de Contato
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Input
                          id="infos-rua"
                          element="input"
                          type="text"
                          label="Rua"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.infos.endereco.rua}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-bairro"
                          element="input"
                          type="text"
                          label="Bairro"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.infos.endereco.bairro}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-cep"
                          element="input"
                          type="text"
                          label="CEP"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.infos.endereco.cep}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-cidade"
                          element="input"
                          type="text"
                          label="Cidade & Estado"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.infos.endereco.cidade}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Informações de Contato
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Input
                          id="infos-telefone"
                          element="input"
                          type="text"
                          label="Telefone de Contato"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.infos.telefone}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-email"
                          element="input"
                          type="text"
                          label="E-mail de Contato"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.infos.email}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-whats"
                          element="input"
                          type="text"
                          label="Número do Whatsapp"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.infos.whats}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Input
                          id="infos-instagram"
                          element="input"
                          type="text"
                          label="Link do Instagram"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.infos.instagram}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel className={classes.tab} value="3">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Input
                          id="acervos-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          initialValue={inst.acervos.area1.titulo}
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area1-chamada"
                          element="input"
                          type="text"
                          label="Chamada do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.acervos.area1.chamada}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Seletor
                          id="acervos-area1-destaque"
                          name="memorial-area1-destaque"
                          onInput={inputHandler}
                          label="Itens do Acervo de Destaque"
                          placeholder="Destaques do Acervo"
                          multiple
                          blank="Selecione o Destaque do Acervo"
                          fullWidth
                          variant="outlined"
                          data={acervo.map((n) => {
                            return { label: n.nome, id: n._id };
                          })}
                          initialValue={inst.acervos.area1.destaque !== null ? inst.acervos.area1.destaque.map((d) => d._id) : []}
                          errorText="Selecione o Arquivo do Acervo."
                          validators={[]}
                          initialValid
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 3 - O Museu
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item xs={6}>
                        <Input
                          id="acervos-area3-subtitulo"
                          element="input"
                          type="text"
                          label="Sub-Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area3.subtitulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area3-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area3.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area3-chamada"
                          element="input"
                          type="text"
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.acervos.area3.chamada}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area3-botao"
                          element="input"
                          type="text"
                          label="Texto do botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area3.botao.texto}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area3-botao-link"
                          element="input"
                          type="text"
                          label="Link do Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area3.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Avatar
                          id="acervos-area3-destaque"
                          name="acervos-area3-destaque"
                          onInput={inputHandler}
                          initialValue={inst.acervos.area3.destaque !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.acervos.area3.destaque.caminho}` : ''}
                          validators={[]}
                          initialValid
                          extraClass={classes.avatar}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 4 - Visitas
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Avatar
                          id="acervos-area4-fundo"
                          name="acervos-area4-fundo"
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area4.fundo !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.acervos.area4.fundo.caminho}` : ''}
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="acervos-area4-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area4.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area4-chamada"
                          element="input"
                          type="text"
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.acervos.area4.chamada}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area4-botao"
                          element="input"
                          type="text"
                          label="Texto do botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area4.botao.texto}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="acervos-area4-botao-link"
                          element="input"
                          type="text"
                          label="Link do Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.acervos.area4.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel className={classes.tab} value="4">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Input
                          id="emprestimo-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValue={inst.emprestimo.area1.titulo}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 2 - Descrição
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item xs={6}>
                        <Draft
                          id="emprestimo-area2-descricao"
                          element="input"
                          type="text"
                          label="Descrição lateral"
                          fullWidth
                          validators={[]}
                          initialValue={inst.emprestimo.area2.descricao}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Avatar
                          id="emprestimo-area2-destaque"
                          name="emprestimo-destaque"
                          onInput={inputHandler}
                          validators={[]}
                          initialValue={inst.emprestimo.area2.destaque !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.emprestimo.area2.destaque.caminho}` : ''}
                          initialValid
                          extraClass={classes.avatar}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel className={classes.tab} value="5">
              <Paper p={3} style={{ padding: '15px' }}>
                <Box mt={3}>
                  <Box my={2}>
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 1 - Cabeçalho
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Input
                          id="faq-area1-titulo"
                          element="input"
                          type="text"
                          label="Título do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area1.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area1-chamada"
                          element="input"
                          type="text"
                          label="Chamada do Cabeçalho"
                          fullWidth
                          validators={[]}
                          initialValid
                          onInput={inputHandler}
                          initialValue={inst.faq.area1.chamada}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 2 - Descrição
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item xs={6}>
                        <Input
                          id="faq-area2-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area2.titulo}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Draft
                          id="faq-area2-descricao"
                          element="input"
                          type="text"
                          label="Descrição lateral"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area2.descricao}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Avatar
                          id="faq-area2-destaque"
                          name="faq-area2-destaque"
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area2.destaque !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.faq.area2.destaque.caminho}` : ''}
                          extraClass={classes.avatar}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 3 - Segundo Bloco Descritivo
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <Avatar
                          id="faq-area3-destaque"
                          name="faq-area3-destaque"
                          onInput={inputHandler}
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area3.destaque !== null ? `${process.env.REACT_APP_BACKEND_IMG}${inst.faq.area3.destaque.caminho}` : ''}
                          extraClass={classes.avatar}
                        />
                        <Input
                          id="faq-area3-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.faq.area3.titulo}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Draft
                          id="faq-area3-descricao"
                          element="input"
                          type="text"
                          label="Descrição lateral"
                          fullWidth
                          validators={[]}
                          initialValue={inst.faq.area3.descricao}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area3-botao"
                          element="input"
                          type="text"
                          label="Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.faq.area3.botao.texto}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area3-botao-link"
                          element="input"
                          type="text"
                          label="Link do Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area3.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 4 - F.A.Q.
                    </Typography>
                    <div className={classes.faq}>
                      {faqs.map((f, index) => (
                        <Accordion expanded={expanded === index} onChange={handleChangeAcord(index)}>
                          <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography>{f.pergunta}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              {f.resposta}
                            </Typography>
                          </AccordionDetails>
                          <AccordionActions>
                            <Button
                              type="button"
                              size="small"
                              color="primary"
                              onClick={() => setEditfaq(f)}
                            >
                              Editar
                            </Button>
                            <Button
                              type="button"
                              size="small"
                              color="error"
                              onClick={() => handleRmvFaq(f)}
                            >
                              Remover
                            </Button>
                          </AccordionActions>
                        </Accordion>
                      ))}
                    </div>
                    <Button
                      type="button"
                      color="primary"
                      size="large"
                      variant="contained"
                      onClick={() => setFaq(true)}
                    >
                      Adicionar Pergunta
                    </Button>
                    <Divider variant="middle" style={{ margin: '30px 0px' }} />
                    <Typography
                      color="textPrimary"
                      align="left"
                      variant="h2"
                      className={classes.titulo}
                    >
                      Área 5 - Pós F.A.Q.
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <Input
                          id="faq-area5-titulo"
                          element="input"
                          type="text"
                          label="Título da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.faq.area5.titulo}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area5-chamada"
                          element="input"
                          type="text"
                          label="Chamada da Área"
                          fullWidth
                          validators={[]}
                          initialValue={inst.faq.area5.chamada}
                          initialValid
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area5-botao"
                          element="input"
                          type="text"
                          label="Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area5.botao.texto}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <Input
                          id="faq-area5-botao-link"
                          element="input"
                          type="text"
                          label="Link do Botão da Área"
                          fullWidth
                          validators={[]}
                          initialValid
                          initialValue={inst.faq.area5.botao.link}
                          onInput={inputHandler}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </TabPanel>
            <Button
              color="secondary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              marginBottom={5}
              classes={classes.button}
            >
              Salvar Conteúdo
            </Button>
            {isLoading && <LoadingSpinner asOverlay />}
            <ErrorMessage error={error} onClear={clearError} />
          </form>
        </TabContext>
      </Container>
      <Modal
        open={Boolean(faq) || Boolean(editFaq)}
        close={handleCloseFaq}
      >
        <Faq
          salvar={handleAddFaq}
          edit={editFaq}
          close={handleCloseFaq}
          atualizar={handleAttFaq}
        />
      </Modal>
      <Alerta open={salvou} close={fechar} tipo="success">Conteúdo atualizado com sucesso!</Alerta>
    </Page>
  );
};
export default Front;
